var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.variant.slug == 'identity-verification')?_c('VerificationInfoA',{on:{"next":_vm.next}}):_c('VerificationInfoB',{on:{"next":_vm.next,"show-why-need-dialog":_vm.showWhyNeedDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }